window.SEARCH = {
    layers: {
        cross: $('.search-top-layer .cross'),
        results: $('.search-results-layer .resultes-list'),
        results_layer: $('.search-results-layer'),
        top: $('.search-top-layer'),
        form: $('.search-top-layer form'),
        top_input: $('.search-top-layer form input'),
        no_results: $('.search-results-layer .no-results'),
        search_btn: $('.search-btn'),
        load: $('.search-top-layer form .load'),
        search_field_id: "search_field"
    },

    init: function () {
        window.SEARCH.layers.search_btn.click(function () {
            window.SEARCH.layers.top.removeClass('hide');
            window.SEARCH.layers.results_layer.removeClass('hide');

            setTimeout(function () {
                window.SEARCH.layers.top.addClass('active');
                window.SEARCH.layers.results_layer.addClass('active');
                document.getElementById(window.SEARCH.layers.search_field_id).focus();
            }, 100);
        });

        window.SEARCH.layers.cross.click(function () {
            window.SEARCH.layers.top.removeClass('active');
            window.SEARCH.layers.results_layer.removeClass('active');

            setTimeout(function () {
                window.SEARCH.layers.top.addClass('hide');
                window.SEARCH.layers.results_layer.addClass('hide');

                window.SEARCH.layers.top_input.val('');
                window.SEARCH.layers.results.html('');

                if(!window.SEARCH.layers.no_results.hasClass('active')) {
                    window.SEARCH.layers.no_results.addClass('active');
                }
            }, 300);
        });

        window.SEARCH.layers.form.submit(function () {
            let query = window.SEARCH.layers.top_input.val();

            if(query != '') {
                window.WS.makeSearch(query);
            }

            return false;
        });


        window.SEARCH.layers.results.on("click", ".item", function () {
            window.SEARCH.search_results_clic($(this).attr('data-key'));
        });
    },

    search_results_clic: function (charger_id) {
        window.CHARGER.open_window(charger_id);
        window.SEARCH.layers.cross.click();

        var search_history = $.cookie('search');
        var search_history_arr = new Array();
        if(typeof search_history != 'undefined') {
            search_history_arr = atob(search_history);
            search_history_arr = JSON.parse(search_history_arr);
        }

        if(search_history_arr.includes(charger_id) == false) {
            search_history_arr.unshift(charger_id);

            if(search_history_arr.length > 10) {
                search_history_arr.pop();
            }

            search_history_arr = JSON.stringify(search_history_arr);
            search_history_arr = btoa(search_history_arr);
            $.cookie('search', search_history_arr, { expires: 30, path: '/', domain: window.domain_in, secure: true });
        }
    },
    
    search_results: function (list) {
        var HTML = '';

        $.each(list, function (index, value) {
            HTML += '<div class="item '+ value.status +'" data-key="'+ index +'">' +
                        '<div class="icon">' +
                        '    <div class="ico"><i class="fad fa-charging-station"></i></div>' +
                        '    <div class="status"><span class="connected">'+ value.code +'</span></div>' +
                        '</div>' +
                        '<div class="description">' +
                        '    <div class="name">'+ value.name +'</div>' +
                        '    <div class="adress">'+ value.address +'</div>' +
                        '    <div class="connector-type">'+ value.connectors +'</div>' +
                        '</div>' +
                    '    <div class="clear"></div>' +
                    '</div>';
        });

        if(HTML != '') {
            window.SEARCH.layers.results.html(HTML);

            if(window.SEARCH.layers.no_results.hasClass('active')) {
                window.SEARCH.layers.no_results.removeClass('active');
            }

            if(!window.SEARCH.layers.results.hasClass('active')) {
                window.SEARCH.layers.results.addClass('active');
            }
        } else {
            window.SEARCH.layers.results.html('');

            if(!window.SEARCH.layers.no_results.hasClass('active')) {
                window.SEARCH.layers.no_results.addClass('active');
            }

            if(window.SEARCH.layers.results.hasClass('active')) {
                window.SEARCH.layers.results.removeClass('active');
            }
        }

        window.SEARCH.disactiveLoad();
    },
    
    activeLoad: function () {
        if(!window.SEARCH.layers.load.hasClass('active')) {
            window.SEARCH.layers.load.addClass('active');
        }
    },

    disactiveLoad: function () {
        if(window.SEARCH.layers.load.hasClass('active')) {
            window.SEARCH.layers.load.removeClass('active');
        }
    }
};
window.SEARCH.init();